
import { VCarouselItem } from "vuetify/lib";

export default VCarouselItem.extend({});
